export enum DrawType {
  Polygon = 'Polygon',
  Point = 'Point',
}

export default DrawType;
